import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "../shared";
import "./VendorSignupPage.css";

const ONBOARDING_PATH = { pathname: "/vendor/onboarding" };

export default function VendorSignupPage() {
  return (
    <div className="vendor-signup-page">
      <Seo
        title="Become a Partner"
        path="/vendor-signup"
        noindex
        description="List your tours, rentals, or activities on Visit All Nepal. Get consistent bookings, weekly payouts, and a free partner dashboard."
      />
      <div className="vendor-signup-card">
        <h1 className="vendor-signup-title">Become a Partner</h1>
        <p className="vendor-signup-sub">
          Sign in or create an account to get started. We’ll ask a few quick details, then you’re in.
        </p>
        <div className="vendor-signup-actions">
          <Link
            to={{ pathname: "/login", state: { from: ONBOARDING_PATH } }}
            className="vendor-signup-btn vendor-signup-btn--primary"
          >
            Sign in
          </Link>
          <Link
            to={{ pathname: "/signup", state: { from: ONBOARDING_PATH } }}
            className="vendor-signup-btn vendor-signup-btn--secondary"
          >
            Create account
          </Link>
        </div>
        <ul className="vendor-signup-trust">
          <li><span className="vendor-signup-trust__icon" aria-hidden="true">✔</span> Get consistent bookings</li>
          <li><span className="vendor-signup-trust__icon" aria-hidden="true">✔</span> Weekly payouts</li>
          <li><span className="vendor-signup-trust__icon" aria-hidden="true">✔</span> Free dashboard &amp; support</li>
        </ul>
        <p className="vendor-signup-khalti">Fast weekly payouts via Khalti by IME</p>
        <p className="vendor-signup-hint">
          Use <strong>Sign in with Google</strong> on the next screen for the fastest way in.
        </p>
      </div>
    </div>
  );
}
